import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute Component
 *
 * - super_admin routes → redirect to /csmadmin (hidden developer login)
 * - tenant routes      → redirect to /login
 */
const ProtectedRoute = ({ children, requiredRole }) => {
    const userJson = localStorage.getItem('csm_user');
    const role     = localStorage.getItem('csm_role');

    // Not logged in at all
    if (!userJson || !role) {
        const loginPath = requiredRole === 'super_admin' ? '/csmadmin' : '/login';
        return <Navigate to={loginPath} replace />;
    }

    // Logged in but wrong role
    if (requiredRole && role !== requiredRole) {
        const loginPath = requiredRole === 'super_admin' ? '/csmadmin' : '/login';
        return <Navigate to={loginPath} replace />;
    }

    return children;
};

export default ProtectedRoute;
